import {Injectable} from "@angular/core";
import {Apollo} from "apollo-angular";
import {Observable} from "rxjs";
import {map, take} from "rxjs/operators";
import {UsanaObject} from "../../usana-object";
import {LoggerService} from "../../common/logger.service";
import {CheckoutUtil} from "../../../checkout/checkout-util";
import {GetEnrollAffiliateLocales, GetEnrollPcLocales, GetRetailLocales} from "./gql-locale";
import {ILocaleView} from "../locale-models";

@Injectable({
    providedIn: 'root'
})
export class GqlLocaleService extends UsanaObject {

    constructor(private apollo: Apollo,
                loggerService: LoggerService) {
        super(loggerService);
    }

    getRetailLocales(): Observable<ILocaleView[]> {
        return this.apollo
            .watchQuery(
                {
                    query: GetRetailLocales
                })
            .valueChanges
            .pipe(take(1), map((data: any) => CheckoutUtil.handleApolloResponse(data, (d) => d.data.getRetailLocales)));
    }

    getEnrollPcLocales(): Observable<ILocaleView[]> {
        return this.apollo
            .watchQuery(
                {
                    query: GetEnrollPcLocales
                })
            .valueChanges
            .pipe(take(1), map((data: any) => CheckoutUtil.handleApolloResponse(data, (d) => d.data.getEnrollPcLocales)));
    }

    getEnrollAffiliateLocales(): Observable<ILocaleView[]> {
        return this.apollo
            .watchQuery(
                {
                    query: GetEnrollAffiliateLocales
                })
            .valueChanges
            .pipe(take(1), map((data: any) => CheckoutUtil.handleApolloResponse(data, (d) => d.data.getEnrollAffiliateLocales)));
    }
}
